import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const assetDepreciationReportTodo = createAsyncThunk('assetDepreciationReport', async ({ params, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: process.env.REACT_APP_API_URL + `reports/asset-depreciation`,
            params: {
                category_id: params?.category_id || undefined,
                from_date: params?.from_date,
                to_date: params?.to_date,
                status: 'Active',
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getSession("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const assetDepreciationReportSlice = createSlice({
    name: 'assetDepreciationReport',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(assetDepreciationReportTodo.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = null
            }
        });
        builder.addCase(assetDepreciationReportTodo.rejected, () => { })
    }
})

export default assetDepreciationReportSlice.reducer;
